import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { GetCheckinEntryDetailDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { useSwapDrawer } from '~/hooks/use-swap-drawer';
import { newPatientFromCheckinEntryDrawerState } from '~/state/patient/atoms';
import { NewPatientFromCheckinEntryDrawerState as NewPatientFromCheckinEntryDrawerStateType } from '~/state/patient/types';

export const useFetchCheckinEntry = () => {
  const {
    state: { isOpen, checkinEntryId },
    handleTransitionEnd,
  } = useSwapDrawer<NewPatientFromCheckinEntryDrawerStateType>(
    newPatientFromCheckinEntryDrawerState,
    ['checkinEntryId'],
  );

  const [getCheckin, { data }] = useLazyQuery(GetCheckinEntryDetailDocument, {
    fetchPolicy: 'network-only',
  });

  const checkinEntry = getNode(data, 'CheckinEntry');

  useEffect(() => {
    if (isOpen && checkinEntryId) {
      getCheckin({
        variables: {
          id: checkinEntryId,
        },
      });
    }
  }, [getCheckin, isOpen, checkinEntryId]);

  return { isOpen, checkinEntry, handleTransitionEnd };
};
